import type { ReactNode } from "react";
import { Divider, Stack, Typography } from "@mui/material";

interface SidePanelSectionHeaderProps {
  action?: ReactNode;
  ariaLabel?: string;
  inset?: boolean;
  title: string;
}

const SidePanelSectionHeader: React.FC<SidePanelSectionHeaderProps> = ({
  action,
  ariaLabel,
  inset = false,
  title,
}) => {
  return (
    <Stack spacing={1.5}>
      <Stack
        direction="row"
        spacing={1}
        sx={{
          alignItems: "center",
          justifyContent: "space-between",
          px: inset ? 2 : undefined,
        }}
      >
        <Typography aria-label={ariaLabel} component="h2" variant="h6">
          {title}
        </Typography>
        {action}
      </Stack>
      <Divider />
    </Stack>
  );
};

export default SidePanelSectionHeader;
